import { Button, Pagination } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate } from "@/shared/client";
import { type RoomType } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, chakra, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const RoomDetail = ({
    rooms,
    currentIdx,
    nextSlide,
    prevSlide,
}: {
    currentIdx: number;
    rooms: RoomType[];
    nextSlide: () => void;
    prevSlide: () => void;
}) => {
    const { onNavigate } = useNewNavigate();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();

    return (
        <Flex w="100%" flexDir="column" gap={isMobile ? "16px" : "80px"}>
            <Flex w="100%" flexDir="column" gap="32px">
                {!isMobile && (
                    <Box
                        sx={{
                            "& p": {
                                color: "#333",
                            },
                        }}
                    >
                        <Text mb={isMobile ? "4px" : "24px"} {...FONT("cormorant", isLaptop ? 48 : 56, 700, 1.2)}>
                            ROOMS
                        </Text>
                        {/* <Text
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(),
                            }}
                            {...FONT("pretendard", isMobile ? 20 : 18, 300, 1.4)}
                        /> */}
                    </Box>
                )}
                <Flex w="100%" gap="40px">
                    {!isMobile && <Box w="2px" bg="#6b6b6b" />}

                    <Box position="relative" flex="1" minHeight="193px">
                        {rooms.map((currentRoom, index) => (
                            <MotionDetailBox
                                display="flex"
                                position="absolute"
                                key={currentRoom.room_idx}
                                flexDir="column"
                                rowGap={isMobile ? "8PX" : "24PX"}
                                initial={{ opacity: index === currentIdx ? 1 : 0 }}
                                animate={{
                                    opacity: index === currentIdx ? 1 : 0,
                                    transition: { duration: 0.7, ease: "easeIn" },
                                }}
                            >
                                <Text {...FONT("notoSerif", isMobile ? 16 : 32, 400, 1.4)}>
                                    {currentRoom.room_name}
                                </Text>

                                <Box>
                                    <Text color="#3b6c8d" {...FONT("notoSerif", isMobile ? 12 : 14, 400, 1.4)}>
                                        Room Type
                                    </Text>
                                    <Text
                                        mt="8px"
                                        color="#6b6b6b"
                                        {...FONT("pretendard", isMobile ? 12 : 16, 300, 1.4)}
                                    >
                                        {currentRoom.room_type}
                                    </Text>
                                </Box>
                                <Box>
                                    <Text color="#3b6c8d" {...FONT("notoSerif", isMobile ? 12 : 14, 400, 1.4)}>
                                        Number of People
                                    </Text>
                                    <Flex mt="8px" gap={isMobile ? "8px" : "16px"}>
                                        <Text
                                            color="#6b6b6b"
                                            {...FONT("pretendard", isMobile ? 12 : 16, 300, 1.4)}
                                        >{`기준 ${currentRoom.people.min}인 ~ 최대 ${currentRoom.people.max}인`}</Text>
                                    </Flex>
                                </Box>
                            </MotionDetailBox>
                        ))}
                    </Box>
                </Flex>
            </Flex>
            <Flex
                flexDir={isMobile ? "column-reverse" : "row"}
                justifyContent={isMobile ? "none" : "space-between"}
                gap={isMobile ? "48px" : "0"}
                p={isMobile ? "0" : "0 40px"}
            >
                <Box>
                    <Button
                        sizeType="large"
                        roundType="none"
                        {...FONT("cormorant", 24, 300, 1.2)}
                        onClick={() =>
                            onNavigate({
                                path: `/rooms/${rooms[currentIdx].room_idx}`,
                            })
                        }
                    >
                        More View
                    </Button>
                </Box>
                <Flex justifyContent="flex-end">
                    <Pagination
                        currentPage={currentIdx}
                        totalPages={rooms.length}
                        nextPage={nextSlide}
                        prevPage={prevSlide}
                        colorMode="black"
                        arrowType="line"
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

const MotionDetailBox = chakra(motion.div);
